import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  authenticatedUser: {},
  authenticatedUserCustomer: {
    fleets: {},
    clusters: {}
  }
}

export const getters = {
  authenticatedUser: state => state.authenticatedUser,
  authenticatedUserCustomer: state => state.authenticatedUserCustomer,

  isRole: (state) => {
    return {
      superAdmin: ['SUPER_ADMIN'].indexOf(state.authenticatedUser.role) !== -1,
      admin: ['SUPER_ADMIN', 'ADMIN'].indexOf(state.authenticatedUser.role) !== -1,
      user: ['SUPER_ADMIN', 'ADMIN', 'USER'].indexOf(state.authenticatedUser.role) !== -1,
      reader: ['SUPER_ADMIN', 'ADMIN', 'USER', 'READER'].indexOf(state.authenticatedUser.role) !== -1
    }
  }
}

export const mutations = {
  setAuthenticatedUser (state, authenticatedUser) {
    state.authenticatedUser = authenticatedUser
  },

  setAuthenticatedUserCustomer (state, authenticatedUserCustomer) {
    state.authenticatedUserCustomer = authenticatedUserCustomer
  }
}

export const actions = {
  async getAuthenticatedUser (context) {
    let error, response
    [error, response] = await to(api.getAuthenticatedUser(context.rootGetters.application))
    if (error || !response) return Promise.reject(error)

    context.commit('setAuthenticatedUser', response.data)
    return Promise.resolve(response)
  },

  async getAuthenticatedUserCustomer (context) {
    let error, response
    [error, response] = await to(api.getAuthenticatedUserCustomer(context.state.authenticatedUser))
    if (error || !response) return Promise.reject(error)

    // Needed to display screen while fleets and clusters are loading
    response.data.fleets = {}
    response.data.clusters = {}
    context.commit('setAuthenticatedUserCustomer', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
